import Service from '../../services'
import { checkAndReturn } from "../../main"

const state = {

}

const getters = {

}

const actions = {
    getPlanForEdit ({ commit }, params) {
        return Service.Plan.getPlanForEdit(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    editPlan ({ commit }, params) {
        return Service.Plan.editPlan(params.payload).then(res => {
            return checkAndReturn(params, res, true)
        })
    },
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
